(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-image"] && !Shopify.designMode) return;
  try {
    // Handle lazy loading with fade-in effect
  document.addEventListener('DOMContentLoaded', function() {
    const lazyImages = document.querySelectorAll('.responsive-image img[loading="lazy"]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          
          // If image is already loaded, show it immediately
          if (img.complete) {
            img.classList.add('loaded');
          } else {
            // Otherwise wait for load event
            img.addEventListener('load', function() {
              img.classList.add('loaded');
            });
            
            // Fallback: if load event doesn't fire, show after a delay
            setTimeout(() => {
              if (!img.classList.contains('loaded')) {
                img.classList.add('loaded');
              }
            }, 1000);
          }
          
          observer.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hotspot"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const hotpoints = document.querySelectorAll('.hotspot');

  hotpoints.forEach((button) => {
    button.addEventListener('click', function () {
      const parentGroup = button.closest('.hotspot-point__group');
      const chip = parentGroup?.querySelector('.hotspot-chip');
      const link = chip?.querySelector('a');
      const isCurrentlyVisible = link?.classList.contains('visible');

      const allChips = document.querySelectorAll('.hotspot-chip');

      allChips.forEach((c) => {
        c.classList.remove('z-[2]', 'pointer-events-auto');
        c.classList.add('z-0', 'pointer-events-none');

        const l = c.querySelector('a');

        if (l) {
          l.classList.remove('visible');
          l.classList.add('invisible');
        }
      });

      if (chip && !isCurrentlyVisible) {
        chip.classList.remove('z-0', 'pointer-events-none');
        chip.classList.add('z-[2]', 'pointer-events-auto');

        if (link) {
          link.classList.remove('invisible');
          link.classList.add('visible');
        }
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swatches-item"] && !Shopify.designMode) return;
  try {
    (function () {

  'use strict';

  const visibleCount = 4;

  document.addEventListener('click', function (e) {

    const link = e.target.closest(
      '[data-view-more-swatches], [data-show-less-swatches]'
    );

    if (!link) return;

    e.preventDefault();
    e.stopPropagation();

    const component = link.closest('swatches-item-component');

    if (!component) return;

    const container = component.querySelector(
      '[data-swatches-hidden]'
    );

    const showMore = component.querySelector(
      '[data-view-more-swatches]'
    );

    const showLess = component.querySelector(
      '[data-show-less-swatches]'
    );

    if (!container || !showMore || !showLess) return;

    const isExpanding = link === showMore;

    const hiddenSwatches = Array.from(
      container.children
    ).slice(visibleCount);

    hiddenSwatches.forEach(function (swatch) {

      swatch.style.setProperty(
        'display',
        isExpanding ? 'block' : 'none',
        'important'
      );

    });

    showMore.style.display = isExpanding ? 'none' : 'block';
    showLess.style.display = isExpanding ? 'block' : 'none';

  });

})();
  } catch(e) { console.error(e); }
})();

})();
